import classNames from "classnames";

import { BFC } from "shared/types";

export const ArticleDelimiterBlock: BFC = ({
  className,
}) => {
  return (
    <hr className={classNames(className)} />
  );
};
